export const ucfirst = children => {
  return typeof children === 'string' && children.length > 0
    ? children[0].toUpperCase() + children.substring(1).toLowerCase()
    : children
}
